import { gql } from "@apollo/client";

export default gql`
  query getPreference{
    getPreference{
        success
        data{
            requireAccountApproval
            autoFormalizeInvoices
        }
        code
        message
    }
}
`
